import { getEventTagColors } from '@/features/events/eventTags';
import * as React from 'react';
import { View } from 'react-native';

export function EventTagDot({
  value,
  size = 10,
  colors: providedColors,
}: {
  value: string;
  size?: number;
  colors?: readonly string[];
}) {
  const colors = providedColors?.length ? providedColors : getEventTagColors(value);

  if (colors.length === 1) {
    return (
      <View
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: colors[0],
        }}
      />
    );
  }

  return (
    <View
      style={{
        width: size,
        height: size,
        borderRadius: size / 2,
        overflow: 'hidden',
        flexDirection: 'row',
      }}>
      {colors.map((color) => (
        <View key={`${value}-${color}`} style={{ flex: 1, backgroundColor: color }} />
      ))}
    </View>
  );
}
